"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStaticTool = buildStaticTool;
exports.buildDynamicTool = buildDynamicTool;
const zod_to_json_schema_1 = __importDefault(require("zod-to-json-schema"));
function buildStaticTool(props) {
    return {
        type: 'function',
        name: props.name,
        description: props.description,
        parameters: (0, zod_to_json_schema_1.default)(props.parameters),
    };
}
function buildDynamicTool(props) {
    return {
        type: 'function',
        name: props.name,
        description: props.description,
        parameters: props.parameters,
    };
}
//# sourceMappingURL=toolFactory.js.map